export { Dimensions as default } from 'react-native-web';
